import { CreateEquipmentForm } from "@smartship-services/ui/forms";
import { useParams } from "react-router-dom";
const CreateEquipmentPage = () => {
  const { vesselId = "" } = useParams();
  return <CreateEquipmentForm vesselId={vesselId} />;
};

export default CreateEquipmentPage;
